if (document.readyState !== "loading") {

  let path = location.pathname;
  let pathArr = path.split("/");
  let tagPath = pathArr.slice(-1)[0];
  let tagArr = tagPath.split("+");
  let selected_main_cat = "";
  let ai_groups = "";
  let lang_groups = "";
  let subject_groups = "";
  let hierarchy_groups = "";
  let programming_groups = "";

  let selected_items = [];


  let item = "";
  for (let i = 0; i < tagArr.length; i++) {
    item = tagArr[i];
    selected_items.push(item);

    if (item == "tob") {
      selected_main_cat = "tob";
    } else if (item == "kids") {
      selected_main_cat = "kids";
    } else if (item == "itnews") {
      selected_main_cat = "itnews";
    }
  }

  let selected_pre = "";
  const selected_mun = localStorage.getItem("selected-municipality");


  if (document.querySelectorAll(".main_cat_select_item")) {
    const main_cat_select_item = document.querySelectorAll(
      ".main_cat_select_item"
    );
    for (let main of main_cat_select_item) {
      if (main.value == selected_main_cat) {
        main.selected = true;
      }
    }
  }
  let aiName = "#ai ." + selected_main_cat + "-ai-group";
  if (document.querySelectorAll(aiName)) {
    ai_groups = document.querySelectorAll(aiName);
    for (let ai of ai_groups) {
      for (let sel_ai of selected_items) {
        if (ai.value == sel_ai) {
          ai.checked = true;
        }
      }
    }
  }

  let langName =
    "#language ." + selected_main_cat + "-teaching-materials-group";
  if (document.querySelectorAll(langName)) {
    ai_groups = document.querySelectorAll(langName);
    for (let lang of ai_groups) {
      for (let sel_lang of selected_items) {
        if (lang.value == sel_lang) {
          lang.checked = true;
        }
      }
    }
  }

  let subjectName = "#subject ." + selected_main_cat + "-subject-group";
  if (document.querySelectorAll(subjectName)) {
    subject_groups = document.querySelectorAll(subjectName);
    for (let subject of subject_groups) {
      for (let sel_subject of selected_items) {
        if (subject.value == sel_subject) {
          subject.checked = true;
        }
      }
    }
  }

  let hierarchyName = "#hierarchy ." + selected_main_cat + "-hierarchy-group";
  if (document.querySelectorAll(hierarchyName)) {
    hierarchy_groups = document.querySelectorAll(hierarchyName);
    for (let hierarchy of hierarchy_groups) {
      for (let sel_hierarchy of selected_items) {
        if (hierarchy.value == sel_hierarchy) {
          hierarchy.checked = true;
        }
      }
    }
  }

  let programmingName =
    "#programming ." + selected_main_cat + "-programming-group";
  if (document.querySelectorAll(programmingName)) {
    programming_groups = document.querySelectorAll(programmingName);
    for (let programming of programming_groups) {
      for (let sel_programming of selected_items) {
        if (programming.value == sel_programming) {
          programming.checked = true;
        }
      }
    }
  }

  if (document.querySelectorAll(".pre_select_item")) {
    const pre_select_item = document.querySelectorAll(".pre_select_item");
    for (let pre of pre_select_item) {
      for (let item of selected_items) {
        if (pre.value == item) {
          pre.selected = true;
          selected_pre = pre.value;
        }
      }
    }
  }
  const kidsGroup = document.querySelectorAll(".kids-group");
  const tobGroup = document.querySelectorAll(".tob-group");
  if (
    selected_main_cat == "kids"
  ) {
    //非表示
    for (let i = 0; i < tobGroup.length; i++) {
      tobGroup[i].style.display = "none";
    }
    //表示
    for (let i = 0; i < kidsGroup.length; i++) {
      kidsGroup[i].style.display = "";
    }
  }
  if (selected_main_cat == "tob" ||
    selected_main_cat == "" ||
    selected_main_cat == null) {
    //表示
    for (let i = 0; i < tobGroup.length; i++) {
      tobGroup[i].style.display = "";
    }
    //非表示
    for (let i = 0; i < kidsGroup.length; i++) {
      kidsGroup[i].style.display = "none";
    }
  }

  const municipalities = document.querySelector("#municipalities");
  const muni_sel = document.querySelectorAll("#municipalities .muni-sel ");
  const mun_select_item = document.querySelectorAll(".mun_select_item");

  const selectedName = "." + selected_pre + "-group";
  const selectPreGroup = document.querySelectorAll(selectedName);

  if (
    selected_pre == "none-prefecture" ||
    selected_pre == "online" ||
    selected_pre == "" ||
    selected_pre == null
  ) {
    //非表示
    municipalities.style.display = "none";
    for (let i = 0; i < muni_sel.length; i++) {
      muni_sel[i].selectedIndex = 0;
    }
  } else {
    for (let i = 0; i < muni_sel.length; i++) {
      muni_sel[i].selectedIndex = 0;
    }
    //表示
    municipalities.style.display = "";
    //非表示
    for (let i = 0; i < mun_select_item.length; i++) {
      mun_select_item[i].style.display = "none";
      mun_select_item[i].setAttribute("disabled", "");
    }
    //表示
    for (let i = 0; i < selectPreGroup.length; i++) {
      selectPreGroup[i].style.display = "";
      selectPreGroup[i].removeAttribute("disabled");
    }
  }

  if (document.querySelectorAll(".mun_select_item")) {
    for (let mun of mun_select_item) {
      for (let item of selected_items) {
        if (mun.value == item) {
          mun.selected = true;
        }
      }
    }
  }
  let checkedlabel = document.getElementById('checkedlabel');
  let checkItem = document.querySelectorAll('input[type=checkbox]:checked');
  let arr = [];
  for (let i = 0; i < checkItem.length; i++) {
    if (checkItem[i].name != "")
      arr.push('<span class="select-tag">' + checkItem[i].name + '</span>');
  }

  let sel_tags = arr.join("");
  try {
    checkedlabel.innerHTML = sel_tags;
  } catch {

  }


  var listItems = document.querySelectorAll('.c-sort-condition-list__item');
  var sortConditionDiv = document.querySelector('.c-sort-condition');
  var toggleText = document.querySelector('.toggle-text');
  var checkbox = document.getElementById('toggle-conditions');

  // アイテム数に基づいてトグルテキストの表示を更新する関数
  function updateToggleTextVisibility() {
    if (window.innerWidth <= 600) { // SP解像度の条件
      toggleText.style.display = (listItems.length >= 11) ? 'inline' : 'none'; // 11個以上の場合に表示
    } else {
      toggleText.style.display = 'none'; // SP解像度以外では非表示
    }
  }

  // リサイズイベントで表示を更新
  window.addEventListener('resize', updateToggleTextVisibility);

  // チェックボックスの変更イベント
  checkbox.addEventListener('change', function () {
    toggleText.textContent = this.checked ? '閉じる' : 'すべて表示';
    updateToggleTextVisibility(); // トグルテキストの表示を更新
  });

  // 初期状態の表示を設定
  if (listItems.length === 0) {
    sortConditionDiv.style.display = 'none';
  } else {
    updateToggleTextVisibility(); // 初期ロード時にも表示状態を更新
  }

}


function makeurl() {
  let main_cat = "";
  let lang_group = "";
  let lang_groups = "";
  let langRes = [];
  let subject_group = "";
  let subject_groups = "";
  let subjectRes = [];
  let ai_group = "";
  let ai_groups = "";
  let aiRes = [];
  let hierarchy_group = "";
  let hierarchy_groups = "";
  let hierarchyRes = [];
  let programming_group = "";
  let programming_groups = "";
  let programmingRes = [];
  let prefecture = "";
  let municipality = "";

  let url = "https://trends.codecamp.jp/blogs/media/tagged/";

  if (document.querySelector("#main-cat")) {
    main_cat = document.querySelector("#main-cat").value;
  }
  let aiName = "#ai ." + main_cat + "-ai-group:checked";
  if (document.querySelectorAll(aiName)) {
    ai_groups = document.querySelectorAll(aiName);
    for (let ai of ai_groups) {
      aiRes.push(ai.value);
    }
  }
  let langName = "#language ." + main_cat + "-teaching-materials-group:checked";
  if (document.querySelectorAll(langName)) {
    lang_groups = document.querySelectorAll(langName);
    for (let lang of lang_groups) {
      langRes.push(lang.value);
    }
  }

  let subjectName = "#subject ." + main_cat + "-subject-group:checked";
  if (document.querySelectorAll(subjectName)) {
    subject_groups = document.querySelectorAll(subjectName);
    for (let subject of subject_groups) {
      subjectRes.push(subject.value);
    }
  }

  let hierarchyName = "#hierarchy ." + main_cat + "-hierarchy-group:checked";
  if (document.querySelectorAll(hierarchyName)) {
    hierarchy_groups = document.querySelectorAll(hierarchyName);
    for (let cla of hierarchy_groups) {
      hierarchyRes.push(cla.value);
    }
  }
  let programmingName = "#programming ." + main_cat + "-programming-group:checked";
  if (document.querySelectorAll(programmingName)) {
    programming_groups = document.querySelectorAll(programmingName);
    for (let cla of programming_groups) {
      programmingRes.push(cla.value);
    }
  }
  let preName = "#prefecture select." + main_cat + "-group";
  if (document.querySelector(preName)) {
    prefecture = document.querySelector(preName).value;
  }

  let munName = "#municipalities select." + main_cat + "-group";
  if (document.querySelector(munName)) {
    municipality = document.querySelector(munName).value;
  }
  // URL生成

  if (main_cat != "none-place" || !main_cat) {
    // url = addURL(url, main_cat);
    url = addURL(url, "itnews");

  }

  if (aiRes.length != 0) {
    ai_group = aiRes.join("+");
    url = addURL(url, ai_group);
  }

  if (langRes.length != 0) {
    lang_group = langRes.join("+");
    url = addURL(url, lang_group);
  }
  if (subjectRes.length != 0) {
    subject_group = subjectRes.join("+");
    url = addURL(url, subject_group);
  }
  if (hierarchyRes.length != 0) {
    hierarchy_group = hierarchyRes.join("+");
    url = addURL(url, hierarchy_group);
  }
  if (programmingRes.length != 0) {
    programming_group = programmingRes.join("+");
    url = addURL(url, programming_group);
  }

  if (prefecture != "none-prefecture" || !prefecture) {
    url = addURL(url, prefecture);
    if (municipality != "none-place" || !municipality) {
      url = addURL(url, municipality);
    }
  }

  localStorage.setItem("selected-main_cat", main_cat);
  localStorage.setItem("selected-prefecture", prefecture);
  localStorage.setItem("selected-municipality", municipality);
  localStorage.setItem("selected-ai", aiRes);
  localStorage.setItem("selected-lang", langRes);
  localStorage.setItem("selected-subject", subjectRes);
  localStorage.setItem("selected-hierarchy", hierarchyRes);
  localStorage.setItem("selected-programming", programmingRes);

  location = url;

  // let test = (document.getElementById("addText").innerText = url);
}





function mainCateChange() {
  const kidsGroup = document.querySelectorAll(".kids-group");
  const tobGroup = document.querySelectorAll(".tob-group");

  const selectorTob = "#prefecture select." + "tob" + "-group";
  const selectedOptNameTob = "#municipalities ." + "tob" + "-group";
  const selectorKids = "#prefecture select." + "kids" + "-group";
  const selectedOptNameKids = "#municipalities ." + "kids" + "-group";
  let checkItems = document.querySelectorAll('input[type=checkbox]');
  let checkedlabel = document.getElementById('checkedlabel');
  checkedlabel.innerHTML = "";

  for (let i = 0; i < checkItems.length; i++) {
    checkItems[i].checked = false;
  }

  if (document.querySelector("#main-cat")) {
    let selboxValue = document.querySelector("#main-cat").value;
    if (selboxValue == "kids") {
      //非表示
      for (let i = 0; i < tobGroup.length; i++) {
        tobGroup[i].style.display = "none";
      }

      //表示
      for (let i = 0; i < kidsGroup.length; i++) {
        kidsGroup[i].style.display = "";
      }

      try {
        document.querySelector(selectorTob).selectedIndex = 0;
        document.querySelector(selectedOptNameTob).selectedIndex = 0;
        document.querySelector(selectorKids).selectedIndex = 0;
        document.querySelector(selectedOptNameKids).selectedIndex = 0;
      } catch {

      }


    }
    if (selboxValue == "tob") {
      //表示
      for (let i = 0; i < tobGroup.length; i++) {
        tobGroup[i].style.display = "";
      }
      //非表示
      for (let i = 0; i < kidsGroup.length; i++) {
        kidsGroup[i].style.display = "none";
      }

      try {
        document.querySelector(selectorTob).selectedIndex = 0;
        document.querySelector(selectedOptNameTob).selectedIndex = 0;
        document.querySelector(selectorKids).selectedIndex = 0;
        document.querySelector(selectedOptNameKids).selectedIndex = 0;
      } catch {

      }

    }
  }


}

function prefectureChange(type) {
  const municipalities = document.querySelector("#municipalities");
  const muni_sel = document.querySelectorAll("#municipalities .muni-sel ");
  const mun_select_item = document.querySelectorAll(".mun_select_item");

  const selector = "#prefecture select." + type + "-group";

  if (document.querySelector(selector)) {
    let selboxValue = document.querySelector(selector).value;

    const selectedName = "." + selboxValue + "-group";
    const selectedOptName = "#municipalities ." + selboxValue + "-opt-group";

    const selectPreGroup = document.querySelectorAll(selectedName);

    if (selboxValue == "none-prefecture" || selboxValue == "online") {
      //非表示
      municipalities.style.display = "none";
      for (let i = 0; i < muni_sel.length; i++) {
        muni_sel[i].selectedIndex = 0;
      }
    } else {
      for (let i = 0; i < muni_sel.length; i++) {
        muni_sel[i].selectedIndex = 0;
      }
      //表示
      municipalities.style.display = "";
      //非表示
      for (let i = 0; i < mun_select_item.length; i++) {
        mun_select_item[i].style.display = "none";
        mun_select_item[i].setAttribute("disabled", "");
      }
      //非表示
      for (let i = 0; i < selectPreGroup.length; i++) {
        selectPreGroup[i].style.display = "";
        selectPreGroup[i].removeAttribute("disabled");
      }
    }
  }
}

function addURL(url, path) {
  if (url.endsWith("/")) {
    url = url + path;
  } else {
    if (path != "") {
      url = url + "+" + path;
    }
  }

  return url;
}




document.querySelectorAll('input[type=checkbox]').forEach(function (element) {


  //チェックを変更すると発生するイベント
  element.addEventListener('change', function (click_element) {
    let checkedlabel = document.getElementById('checkedlabel');
    let checkItem = document.querySelectorAll('input[type=checkbox]:checked');
    let arr = [];
    for (let i = 0; i < checkItem.length; i++) {
      if (checkItem[i].name != "")
        arr.push('<span class="select-tag">' + checkItem[i].name + '</span>');
    }

    let sel_tags = arr.join("");
    try {
      checkedlabel.innerHTML = sel_tags;
    } catch {

    }
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//   const carousel = document.querySelector('.custom-carousel');
//   const carouselContent = document.querySelector('.custom-carousel-content');
//   const carouselItems = document.querySelectorAll('.custom-carousel-item');
//   const prevButton = document.querySelector('.custom-carousel-prev-button');
//   const nextButton = document.querySelector('.custom-carousel-next-button');

//   let currentIndex = 0;
//   try{
//     let itemWidth = carouselItems[0].offsetWidth;

  
//   const itemMargin = 15;
  
//   prevButton.addEventListener('click', showPrevSlide);
//   nextButton.addEventListener('click', showNextSlide);

//   let isDragging = false;
//   let startPosition = 0;
//   let currentTranslate = 0;
//   let prevTranslate = 0;
//   let animationID = 0;

//   carouselContent.addEventListener('mousedown', dragStart);
//   carouselContent.addEventListener('touchstart', dragStart);

//   carouselContent.addEventListener('mousemove', dragging);
//   carouselContent.addEventListener('touchmove', dragging);

//   carouselContent.addEventListener('mouseup', dragEnd);
//   carouselContent.addEventListener('mouseleave', dragEnd);
//   carouselContent.addEventListener('touchend', dragEnd);
// }catch{

// }
//   window.addEventListener('resize', handleResize);

//   function dragStart(event) {
//     if (event.type === 'touchstart') {
//       startPosition = event.touches[0].clientX;
//     } else {
//       startPosition = event.clientX;
//       event.preventDefault();
//     }
//     isDragging = true;
//     animationID = requestAnimationFrame(animation);
//   }

//   function dragging(event) {
//     if (isDragging) {
//       let currentPosition = 0;
//       if (event.type === 'touchmove') {
//         currentPosition = event.touches[0].clientX;
//       } else {
//         currentPosition = event.clientX;
//       }
//       currentTranslate = prevTranslate + currentPosition - startPosition;
//     }
//   }

//   function dragEnd() {
//     isDragging = false;
//     cancelAnimationFrame(animationID);

//     const movedBy = currentTranslate - prevTranslate;

//     if (movedBy < -100 && currentIndex < carouselItems.length - 1) {
//       currentIndex += 1;
//     }

//     if (movedBy > 100 && currentIndex > 0) {
//       currentIndex -= 1;
//     }

//     setPositionByIndex();
//   }

//   function animation() {
//     updateSlides();
//     if (isDragging) {
//       requestAnimationFrame(animation);
//     }
//   }

//   function setPositionByIndex() {
//     currentTranslate = currentIndex * -itemWidth;
//     prevTranslate = currentTranslate;
//     updateSlides();
//   }

//   function showPrevSlide() {
//     currentIndex = (currentIndex - 1 + carouselItems.length) % carouselItems.length;
//     updateSlides();
//   }

//   function showNextSlide() {
//     currentIndex = (currentIndex + 1) % carouselItems.length;
//     updateSlides();
//   }

//   function updateSlides() {
//     carouselItems.forEach((item, index) => {
//       item.classList.remove('active');
//       if (index === currentIndex) {
//         item.classList.add('active');
//       }
//     });

//     const translateX = (itemWidth + itemMargin) * currentIndex;
//     carouselContent.style.transform = `translateX(calc(50% - ${translateX}px - ${itemWidth / 2}px))`;
//   }

//   function handleResize() {
//     itemWidth = carouselItems[0].offsetWidth;
//     setPositionByIndex();
//   }

  // updateSlides();
// });